let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ectNf")).then(() => parcelRequire('8p9AR'));